import { PropsWithChildren } from 'react'
import classNames from 'classnames'

export type BadgeVariant = 'default' | 'linkPrimary'

type BadgeProps = PropsWithChildren<{
    variant?: BadgeVariant
    className?: string
}>

const getVariantClassnames = (variant: BadgeVariant) => {
    const variants: Record<BadgeVariant, string> = {
        default: 'border border-neutral-300 bg-white text-subtle',
        linkPrimary: 'border border-linkPrimary bg-linkPrimary text-white',
    }

    return variants[variant]
}

export const Badge: React.FC<BadgeProps> = (props) => {
    const { children, className, variant = 'default' } = props
    const baseClassName = 'text-label-xsmall px-2 py-1 rounded-lg'
    const variantClassName = getVariantClassnames(variant)
    const badgeClassName = classNames(
        baseClassName,
        variantClassName,
        className
    )

    return <div className={badgeClassName}>{children}</div>
}
